/* eslint-disable @typescript-eslint/no-explicit-any */
import { DynamicWidgetRenderer as CommonDynamicWidgetRenderer } from "@moim/common";
import { useLocation } from "wouter";
import React from "react";

interface IProps {
  content: string;
  onDomClick?(e: React.MouseEvent<any>): void;
}

const DynamicWidgetRenderer = ({ content, onDomClick }: IProps) => {
  const [, setLocation] = useLocation();
  const redirectHandler = React.useCallback((url: string) => {
    setLocation(url);
  }, []);

  return (
    <CommonDynamicWidgetRenderer
      content={content}
      redirectCallback={redirectHandler}
      onDomClick={onDomClick}
    />
  );
};

export default DynamicWidgetRenderer;
